<div class="card-div active shadow">
  <div class="card-div-inner" style="width:100% !important;">
    @for (item of this.faqData; track item; let i = $index) {
      <div>
        <label class="title" style="margin-top:30px;margin-bottom:15px ;">{{item.title}}</label>
        @for (item2 of item.questions; track item2; let j = $index) {
          <div>
            <label style="margin-bottom: 5px;">@if (!this.booleanValues[i][j]) {
              <span (click)="showAnswers(i,j)"
              class="boxAdd">+</span>
              }@if (this.booleanValues[i][j]) {
              <span (click)="showAnswers(i,j)"
              class="boxAdd">-</span>
              } <span class="question">{{item2.question}}</span>
            </label>
            <div [hidden]="!this.booleanValues[i][j]" [innerHTML]="item2.answer" class="answer"></div>
          </div>
        }
      </div>
    }

  </div>
</div>